import React from 'react'
import Div from '../Div'
import ContactInfoWidget from '../Widget/ContactInfoWidget'
import MenuWidget from '../Widget/MenuWidget'
import Newsletter from '../Widget/Newsletter'
import SocialWidget from '../Widget/SocialWidget'
import TextWidget from '../Widget/TextWidget'
import Spacing from '../Spacing'
import './footer.scss'

export default function Footer({copyrightText, logoSrc, logoAlt, text}) {
  const copyrightLinks = [
    {
      title: 'Privacy Policy',
      href: '/privacy'
    },
    {
      title: 'Terms of Service',
      href: '/terms'
    }
  ]

  const paymentMethods = [
    {
      src: '/images/payments/visa.png',
      alt: 'Visa'
    },
    {
      src: '/images/payments/mastercard.png',
      alt: 'Mastercard'
    },
    {
      src: '/images/payments/amex.png',
      alt: 'American Express'
    }
  ]
  
  const serviceMenu = [
    {
      title: 'Web Design & Development',
      href: '/service/website-design-and-development'
    },
    {
      title: 'Blockchain Development',
      href: '/service/blockchain-development'
    },
    {
      title: 'Graphic Designing',
      href: '/service/graphic-design'
    },
    {
      title: 'Digital marketing',
      href: '/service/digital-marketing'
    },
    {
      title: 'Twitch Packages',
      href: '/service/twitch-packages'
    },
    {
      title: 'Sales & Customer Service',
      href: '/service/sales-agents-customer-service'
    },
  ]

  return (
    <footer className="cs-fooer">
      <Spacing lg='50' md='80'/>
      <Div className="cs-fooer_main">
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <TextWidget 
                  logoSrc='/images/footer_logo.png' 
                  logoAlt='Logo'
                  text ='Welcome to Acsytech, where innovation meets excellence in the realm of software solutions.'
                />
                <SocialWidget/>
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <MenuWidget menuItems={serviceMenu} menuHeading='Services'/>
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <ContactInfoWidget title='Contact Us'/>
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <Newsletter 
                  title='Subscribe' 
                  subtitle='' 
                  placeholder='example@gmail.com'
                />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Div className="container">
        <Div className="cs-bottom_footer">
          <Div className="cs-bottom_footer_left">
            <Div className="cs-copyright">Copyright © 2026 Acsytech.</Div>
          </Div>
          <Div className="cs-bottom_footer_right">
            <MenuWidget menuItems={copyrightLinks} variant=' cs-style2'/>
            <Div className="cs-payment_methods" aria-label="Accepted payment methods">
              {paymentMethods.map((method) => (
                <img
                  key={method.alt}
                  src={method.src}
                  alt={method.alt}
                  className="cs-payment_method_logo"
                  loading="lazy"
                />
              ))}
            </Div>
          </Div>
        </Div>
      </Div>
    </footer>
  )
}
